import React, { useEffect, useCallback } from 'react';
import classNames from 'classnames';

// styles
import './style.scss';

// antd component
import { notification } from 'antd';

// assets
import { LoadingOutlined, CheckCircleOutlined } from '@ant-design/icons';
//import CustomIcons from 'components/CustomIcons';

function NotificationHandleNew({
  Loading,
  Successful,
  isNew,
  // default props
  message,
  messageSuccess,
  description,
  descriptionError,
  //default
  className,
}) {

  // Loading Notifications
  useEffect(() => {
    if ((Loading && !Successful && isNew) || (isNew && Successful)) {
      newNotification(Loading, isNew, Successful);
    }
  }, [
    Loading, isNew, Successful
  ]);
  
  const newNotification = useCallback((Loading, isNew, Successful) => (
    notification.info({
      duration: 2,
      icon: (
        <>
          {Loading && !Successful && (
            <LoadingOutlined style={{ color: '#F59C05' }} />
          )}
          {Successful && <CheckCircleOutlined style={{ color: '#28A745' }} />}
        </>
      ),
      message: Successful ? messageSuccess : message,
      description: Successful
        ? description
        : descriptionError,
    })
  ), [description, descriptionError, messageSuccess, message, Loading, isNew, Successful]);

  return <></>;

};

NotificationHandleNew.defaultProps = {
  message: 'Création!',
  messageSuccess: 'Établi!',
  description: `Données enregistrées avec succès!`,
  descriptionError: 'Un instant…',
};

export default NotificationHandleNew;